<template>
  <cadastro-base
    :salvar="salvar"
    :cancelar="cancelar"
  >
    <template slot="conteudo">
      <div slot="modal-title">
        <h5>Configuração de envio automático de documentos por rotinas</h5>
        <fieldset class="font-weight-bold text-muted">
          Nos informe a forma que deseja que o sistema faça o envio dos documentos de forma automáticas.
        </fieldset>
        <hr
          class="mx-0 mt-0 mb-2"
          style="border-top: 1px solid #a3a4a66b !important;"
        >
      </div>

      <template v-for="grupo in $options.GRUPOS">
        <h4 :key="`titulo-${grupo.nome}`">
          {{ grupo.nome }}
          <modal-info-envio-automatico v-bind="grupo.modalProps || {}" />
        </h4>

        <b-row :key="`desc-${grupo.nome}`">
          <b-col cols="12" class="mb-2">
            <fieldset class="font-weight-bold mb-1">
              Selecione o tipo de envio automático que você deseja.
            </fieldset>
          </b-col>
        </b-row>

        <b-row :key="`rotinas-${grupo.nome}`" class="mt-1">
          <b-col
            v-for="rotina in grupo.rotinas"
            :key="rotina.tipoRotina"
            cols="auto"
            class="mb-2"
            style="min-width: 200px;"
          >
            <fieldset class="font-weight-bold mb-1">
              {{ rotina.titulo }}
            </fieldset>

            <b-form-group
              v-if="rotina.campoExtra"
              :label="rotina.campoExtra.label"
              :label-for="`campoExtra-${rotina.tipoRotina}`"
              class="mb-1"
            >
              <b-form-select
                :id="`campoExtra-${rotina.tipoRotina}`"
                v-model="form[rotina.campo][rotina.campoExtra.campo]"
                :options="rotina.campoExtra.options"
                :disabled="!!rotina.campoExtra.disabled"
                style="max-width: 160px;"
              />
            </b-form-group>

            <b-form-group class="mb-1">
              <b-form-radio
                v-model="form[rotina.campo].tipoEnvio"
                :name="`tipoEnvio-${rotina.tipoRotina}`"
                :value="0"
              >
                Não enviar
              </b-form-radio>
              <b-form-radio
                v-model="form[rotina.campo].tipoEnvio"
                :name="`tipoEnvio-${rotina.tipoRotina}`"
                :value="1"
                class="mt-50"
              >
                Na atualização
              </b-form-radio>
              <b-form-radio
                v-model="form[rotina.campo].tipoEnvio"
                :name="`tipoEnvio-${rotina.tipoRotina}`"
                :value="2"
                class="mt-50"
              >
                Dia selecionado
              </b-form-radio>
            </b-form-group>

            <div class="d-flex align-items-center mt-1">
              <b-form-input
                :id="`diaEnvio-${rotina.tipoRotina}`"
                v-model="form[rotina.campo].diaEnvio"
                type="number"
                min="1"
                max="31"
                placeholder="Dia"
                :disabled="form[rotina.campo].tipoEnvio !== 2"
                :state="diaInvalido(rotina.campo) ? false : null"
                style="max-width: 80px;"
                @blur="formatarDia(rotina.campo)"
              />
              <empresas-envio-automatico
                :tipo-rotina="rotina.tipoRotina"
                :titulo-rotina="rotina.titulo"
                :empresas-ids="form[rotina.campo].empresasIds"
                @atualizar="atualizarEmpresas($event)"
              />
              <historico-envio-automatico
                v-if="form[rotina.campo].tipoEnvio !== 0"
                :tipo-rotina="rotina.tipoRotina"
                :titulo-rotina="rotina.titulo"
              />
            </div>
          </b-col>
        </b-row>

        <fieldset
          :key="`footer-${grupo.nome}`"
          style="margin-top: 10px;"
          class="font-weight-bold text-muted"
        >
          O envio "Na atualização" ocorre sempre que o documento for atualizado pelo sistema. O envio "Dia selecionado" ocorre mensalmente no dia configurado.
        </fieldset>

        <hr
          v-if="grupo !== $options.GRUPOS[$options.GRUPOS.length - 1]"
          :key="`hr-${grupo.nome}`"
          class="my-2"
          style="border-top: 1px solid #a3a4a66b !important;"
        >
      </template>
      <!--
          Futuros grupos: adicionar novas entradas no array GRUPOS (script).
          Cada rotina pode declarar campoExtra para um dropdown adicional (ex: Status, Arquivo a enviar).
        -->
    </template>
  </cadastro-base>
</template>

<script>
import '@core/scss/vue/libs/vue-select.scss'
import api from './shared/services/api'
import EventBus from '../shared/mixins/event-bus/eventBus'
import apiTermos from '../shared/services/api-termos'

const STATUS_SITUACAO_FISCAL = [
  { value: 0, text: 'Regular' },
  { value: 1, text: 'Irregular' },
  { value: 2, text: 'Ambas' },
]

const TIPO_DOCUMENTO_DCTFWEB = [
  { value: 0, text: 'Guia' },
  { value: 1, text: 'Recibo' },
  { value: 2, text: 'Ambos' },
]

const GRUPOS = [
  {
    nome: 'Federal',
    modalProps: {
      condicaoDocumento: 'documento compatível com o status configurado',
      monitoramentoTexto: 'monitoramento ativo',
    },
    rotinas: [
      {
        tipoRotina: 6,
        titulo: 'Situação Fiscal',
        campo: 'situacaoFiscal',
        campoExtra: {
          campo: 'statusSituacaoFiscal',
          label: 'Status',
          options: STATUS_SITUACAO_FISCAL,
          default: 0,
        },
      },
      {
        tipoRotina: 12,
        titulo: 'DCTFWeb',
        campo: 'dctfWeb',
        campoExtra: {
          campo: 'tipoDocumentoDctfWeb',
          label: 'Documento',
          options: TIPO_DOCUMENTO_DCTFWEB,
          default: 2,
        },
      },
      {
        tipoRotina: 18,
        titulo: 'Simples Nacional',
        campo: 'simplesNacional',
        campoExtra: {
          campo: 'tipoDocumentoSimplesNacional',
          label: 'Documentos',
          options: [{ value: 0, text: 'Declaração' }],
          default: 0,
          disabled: true,
        },
      },
    ],
  },
  {
    nome: 'Certidões',
    rotinas: [
      { tipoRotina: 1, titulo: 'RFB/PGFN', campo: 'cndRfbPgfn' },
      { tipoRotina: 2, titulo: 'FGTS', campo: 'cndFgts' },
      { tipoRotina: 3, titulo: 'Trabalhista', campo: 'cndTrabalhista' },
      { tipoRotina: 4, titulo: 'Estadual', campo: 'cndEstadual' },
      { tipoRotina: 10, titulo: 'Municipal', campo: 'cndMunicipal' },
    ],
  },
]

const TODAS_ROTINAS = GRUPOS.flatMap(g => g.rotinas)

function configVazia(rotina) {
  const config = { tipoEnvio: 0, diaEnvio: null, empresasIds: [] }
  if (rotina.campoExtra) {
    config[rotina.campoExtra.campo] = rotina.campoExtra.default
  }
  return config
}

function estadoInicial() {
  const state = {}
  TODAS_ROTINAS.forEach(r => { state[r.campo] = configVazia(r) })
  return state
}

export default {
  name: 'EnvioAutomaticoView',
  GRUPOS,
  components: {
    CadastroBase: () => import('@pilar/components/cadastro-base/CadastroBase.vue'),
    EmpresasEnvioAutomatico: () => import('./shared/components/EmpresasEnvioAutomatico.vue'),
    HistoricoEnvioAutomatico: () => import('./shared/components/HistoricoEnvioAutomatico.vue'),
    ModalInfoEnvioAutomatico: () => import('./shared/components/ModalInfoEnvioAutomatico.vue'),
  },
  data() {
    return {
      form: estadoInicial(),
    }
  },
  watch: {
    form: {
      deep: true,
      handler(form) {
        TODAS_ROTINAS.forEach(r => {
          if (form[r.campo].tipoEnvio !== 2) {
            // eslint-disable-next-line no-param-reassign
            form[r.campo].diaEnvio = null
          }
        })
      },
    },
  },
  created() {
    this.carregar()
  },
  methods: {
    carregar() {
      api.getConfigs()
        .then(payload => {
          const configs = payload.data
          configs.forEach(config => {
            const rotina = TODAS_ROTINAS.find(r => r.tipoRotina === config.tipoRotina)
            if (!rotina) return

            const novoConfig = {
              tipoEnvio: config.tipoEnvio,
              diaEnvio: config.diaEnvio || null,
              empresasIds: config.empresasIds || [],
            }
            if (rotina.campoExtra) {
              novoConfig[rotina.campoExtra.campo] = config[rotina.campoExtra.campo] ?? rotina.campoExtra.default
            }
            this.form[rotina.campo] = novoConfig
          })
        })
        .catch(err => {
          throw err
        })
    },
    cancelar() {
      this.$router.push({ name: 'dashboard-analitico' })
    },
    diaInvalido(campo) {
      const config = this.form[campo]
      if (config.tipoEnvio !== 2) return false
      const dia = parseInt(config.diaEnvio, 10)
      return !config.diaEnvio || Number.isNaN(dia) || dia < 1 || dia > 31
    },
    salvar() {
      return new Promise((resolve, reject) => {
        const invalidas = TODAS_ROTINAS.filter(r => this.diaInvalido(r.campo))
        if (invalidas.length > 0) {
          const nomes = invalidas.map(r => r.titulo).join(', ')
          reject(new Error(`Informe um dia válido (1 a 31) para: ${nomes || ''}`))
          return
        }

        apiTermos.getPendentes([2])
          .then(r => {
            if (r.data?.length) {
              EventBus.$emit('termosPendentes', r.data)
              EventBus.$once('termoAceito', () => this.executarSalvamento(resolve, reject))
            } else {
              this.executarSalvamento(resolve, reject)
            }
          })
          .catch(() => this.executarSalvamento(resolve, reject))
      })
    },

    executarSalvamento(resolve, reject) {
      const promises = TODAS_ROTINAS.map(rotina => {
        const config = this.form[rotina.campo]
        const payload = {
          tipoRotina: rotina.tipoRotina,
          tipoEnvio: config.tipoEnvio,
          diaEnvio: config.tipoEnvio === 2 ? config.diaEnvio : null,
        }
        if (rotina.campoExtra) {
          payload[rotina.campoExtra.campo] = config[rotina.campoExtra.campo]
        }
        return api.salvarConfig(payload)
      })

      Promise.all(promises)
        .then(() => {
          resolve('Configurações de envio automático salvas com sucesso')
        })
        .catch(error => {
          reject(error || 'Erro ao salvar configurações')
        })
    },
    formatarDia(campo) {
      const valor = this.form[campo].diaEnvio
      if (valor && +valor > 0 && +valor < 10) {
        this.form[campo].diaEnvio = `0${+valor}`
      }
    },
    atualizarEmpresas({ tipoRotina, empresasIds }) {
      const rotina = TODAS_ROTINAS.find(r => r.tipoRotina === tipoRotina)
      if (rotina) {
        this.form[rotina.campo].empresasIds = empresasIds
      }
    },
  },
}
</script>
